import reduxWebsocket from '@giantmachines/redux-websocket'
import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import authSlice, { getCurrentUser } from './features/auth/authSlice'
import spacesSlice from './features/spaces/spaceSlice'
import mapSlice from './features/map/mapSlice'
import boothReducer from './features/booth/reducers'
import modalSlice from './features/modals/modalSlice'
import notificationsSlice from './features/notifications/notificationsSlice'
import eventPreviewSlice from './features/auth/eventPreviewSlice'
import eventSliceSlice from './features/events/eventSlice'
import editProfileSlice from './features/profile/editProfileSlice'
import contextualHelpSlice from './features/contextual_help/contextualHelpSlice'
import imageLibrarySlice from './features/image_library/imageLibrarySlice'
import importExportSlice from './features/export_import/importExportSlice'
import websocketSlice from './features/websocket/websocketSlice'
import attendeeSlice from './features/attendees/attendeeSlice'
import parseWebsocketPayload from './features/websocket/parseWebsocketPayload'

const rootReducer = combineReducers({
    spaces: spacesSlice,
    booth: boothReducer,
    map: mapSlice,
    auth: authSlice,
    eventPreview: eventPreviewSlice,
    event: eventSliceSlice,
    modals: modalSlice,
    notifications: notificationsSlice,
    editProfile: editProfileSlice,
    contextualHelp: contextualHelpSlice,
    imageLibrary: imageLibrarySlice,
    importExport: importExportSlice,
    attendee: attendeeSlice,
    websocket: websocketSlice,
})

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(
        reduxWebsocket({ reconnectOnClose: false }), // reconnect is done by WebsocketProvider
        parseWebsocketPayload,
    ),
})

store.dispatch(getCurrentUser())

export type RootState = ReturnType<typeof rootReducer>
export default store
